module.exports = __webpack_public_path__ + "img/Widgetf.167d9cf1.png";